import React from 'react'
import { Grid,Skeleton} from "@mui/material";

const Cargando = () => {
  // Definición de rows y columns (ajusta según corresponda)
  const rows = [1, 1];
  const columns = [0, 2];
  // Número de bloques skeleton (en este caso 4)
  const skeletonItemsCount = 6;
  return (
    <Grid container justifyContent={'center'} style={{height:'100vh'}}>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.6rem 1rem",
          // backgroundColor: "#0d0d10",
          borderBottom: "0.01vw solid #1f1f1f",
          height: "7vh",
          width:'100%'
        }}
      >
        {/* Izquierda: logo + botones */}
        <Grid style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Skeleton variant="circular" animation="wave" width={'3vw'} height={'6vh'} sx={{ }} />
          <Skeleton variant="circular" animation="wave" width={'2vw'} height={'2vw'} sx={{ }} />
          <Skeleton variant="circular" animation="wave" width={'2vw'} height={'2vw'} sx={{ }} />
          <Skeleton variant="rounded" animation="wave" width={'8vw'} height={'4vh'} sx={{  borderRadius: 1 }} />
        </Grid>

        {/* Centro: nombre del centro */}
        <Skeleton variant="text" animation="wave" width={'8vw'} height={'4vh'} sx={{ }} />

        {/* Derecha: reloj + logo */}
        <Grid style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Skeleton variant="rectangular" animation="wave" width={'12vw'} height={'5vh'} sx={{  borderRadius: 2 }} />
          <Skeleton variant="rectangular" animation="wave" width={'6vw'} height={'5vh'} sx={{  borderRadius: 1 }} />
        </Grid>
      </Grid>


      <Grid container justifyContent="center" alignItems="center" marginBottom="2vh" >
        {Array.from({ length: skeletonItemsCount }).map((_, itemIndex) => (
          <Grid
            key={`skeleton-block-${itemIndex}`}
            item xs={4}
            style={{
              width: "37vw",
              height: "38vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "1vh",
            }}
          >
            <Grid container justifyContent="center" width="30vw">
              {rows.map((row, rowIndex) => (
                <Grid
                  container
                  item xs={12}
                  key={`row-${rowIndex}-${itemIndex}`}
                  justifyContent="center"
                  style={{ marginTop: rowIndex > 0 ? "0.4vh" : "0vh" }}
                >
                  {columns.map((col, colIndex) => (
                    <Grid
                      item xs={6}
                      key={`col-${rowIndex}-${colIndex}-${itemIndex}`}
                    >
                      <Skeleton
                        variant="rounded"
                        animation="wave"
                        width="98.5%"
                        height="16vh"
                      />
                    </Grid>
                  ))}
                </Grid>
              ))}
            </Grid>
            {/* Skeleton de texto debajo de las filas */}
            <Skeleton
              variant="rounded"
              animation="wave"
              height="14vh"
              width="89.6%"
              style={{ marginTop: "0.4vh", marginLeft: "-0.2vw" }}
            />
          </Grid>
        ))}
      </Grid>
      
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.6rem 1rem",
          // backgroundColor: "#0d0d10",
          borderTop: "0.01vw solid #1f1f1f",
          height: "7vh",
          width:'100%'
        }}
      >
        {/* Izquierda: logo + botones */}
        <Grid style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Skeleton variant="rounded" animation="wave" width={'8vw'} height={'5vh'} sx={{  borderRadius: 1 }} />
        </Grid>

        {/* Derecha: reloj + logo */}
        <Grid style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Skeleton variant="rectangular" animation="wave" width={'12vw'} height={'5vh'} sx={{  borderRadius: 2 }} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Cargando